import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CloseConfirmComponent } from 'src/app/admin/close-confirm/close-confirm.component';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { TimeChallengeComponent } from '../time-challenge.component';

@Component({
  selector: 'vex-new-time-challenge',
  templateUrl: './new-sub-time-challenge.component.html',
  styleUrls: ['./new-sub-time-challenge.component.scss']
})
export class NewSubTimeChallengeComponent implements OnInit {
  i18nTitle: any = {};

  constructor(@Inject(MAT_DIALOG_DATA) private item: any['item'],private dialogRef: MatDialogRef<TimeChallengeComponent>, private translate: TranslateService, public restService: RestService, public guiService: GuiService,private dialog: MatDialog) { }

  ngOnInit(): void {
    console.debug(this.item)
  }

  confirmClose(){
    this.dialog.open(CloseConfirmComponent,{
      disableClose: true,
      hasBackdrop: true,
      panelClass: 'close-dialog-modalbox'
    }).afterClosed().subscribe((ris)=>{
      if(ris == 'true'){
        this.dialogRef.close()
      }
    })
  }

  submit(){
    setTimeout(() => this.guiService.showSpinner = true, 0);
    const param = {
      userId: this.guiService.userLogged.user.id,
      challengeId: this.item._id,
      challenge: {
        i18nTitle: {
          "EN": this.i18nTitle['EN'],
          "IT": this.i18nTitle['IT']
        },
        weeks: []
      }
    }

    this.restService.postService('node', '/add-challenge-to-time-challenge', param).subscribe((ris) => {
      this.guiService.showSpinner = false;
      this.dialogRef.close('done')
    })
  }

}
